import React from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'
import { Combobox } from '@node-space/ui-components'
import { useTranslation } from 'react-i18next'
import { SourcePayWallet } from '../../../Pay/types'

interface WalletSelectorProps {
  register: UseFormRegisterReturn
  sourceWalletAtom: SourcePayWallet | null
  walletsOptions: any[]
  isLoadingWalletOptions: boolean
  errorText?: string
}

export const WalletSelector = ({
  register,
  sourceWalletAtom,
  walletsOptions,
  isLoadingWalletOptions,
  errorText,
}: WalletSelectorProps) => {
  const { t } = useTranslation()

  return (
    <Combobox
      {...register}
      key={sourceWalletAtom?.walletId}
      modal
      id="source-wallet"
      testId="source-wallet"
      items={walletsOptions || []}
      label={t('wallets.fiatSend.walletToSendFrom')}
      loading={isLoadingWalletOptions}
      loadingInline={isLoadingWalletOptions}
      onChange={() => null}
      defaultValue={sourceWalletAtom?.walletId}
      errorText={errorText}
      disabled={isLoadingWalletOptions || !!sourceWalletAtom}
    />
  )
}
